import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import LangSelector from "../../components/LangSelctor";
import ApiCommonContent from "../../services/GenericContent";
import "./styles.scss";
import { CommonContent, ContentKey } from "../../types/Types";

const Settings = () => {
  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  useEffect(() => {
    if (!commonContent) {
      ApiCommonContent.getContent().then((content) => {
        setCommonContent(content);
      });
    }
  }, [commonContent]);

  const onchangeLang = () => {
    setCommonContent(undefined)
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Container className="containerWhite" maxWidth="md">
        <AppBar position="static">
          <Toolbar className="toolBarBlue">
            <IconButton
              onClick={() => {
                window.history.back();
              }}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {ApiCommonContent.getKeyValue(commonContent, ContentKey.SETTINGS)}
            </Typography>
          </Toolbar>
        </AppBar>
        {commonContent && <LangSelector onchangeLang={onchangeLang} content={commonContent} />}
      </Container>
    </React.Fragment>
  );
};

export default Settings;
